export const SET_GENERATE_NEW_SESSION_FLAG = "SET_GENERATE_NEW_SESSION_FLAG";
export const SET_STATE_FOR_NEW_SESSION = "SET_STATE_FOR_NEW_SESSION";
export const SET_RESET_FUNCTION_FLAG = "SET_RESET_FUNCTION_FLAG";



// WEBPACK FOOTER //
// ./modules/generate-new-session/actions/actionTypes.ts